import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import EfImg from '@elem/ui/ef-img';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper';
import React, { useEffect, useState } from 'react';
import gtm from '@/utils/gtm';

interface BlogType {
    img: string;
    star?: number;
    text: string;
    author: string;
}
export default function F() {
    const { t } = useLang('bkw');
    const [gap, setGap] = useState<number>(16);
    const blogs: BlogType[] = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1738831699179/5_1.jpg',
            star: 5,
            text: t('F_blog1_text'),
            author: t('F_blog1_author'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1738831698543/5_2.jpg',
            star: 5,
            text: t('F_blog2_text'),
            author: t('F_blog2_author'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1738831698960/5_3.jpg',
            star: 5,
            text: t('F_blog3_text'),
            author: t('F_blog3_author'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1738831698327/5_4.jpg',
            star: 5,
            text: t('F_blog4_text'),
            author: t('F_blog4_author'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1738831698750/5_5.jpg',
            star: 5,
            text: t('F_blog5_text'),
            author: t('F_blog5_author'),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth < 1024) {
                setGap(16);
            } else {
                setGap(24);
            }
        }
    }, []);

    return (
        <div id="bkw-F" className={`bkw-F bkw-box inner ${css['bkw-F']}`}>
            <EfSpec />
            <div className="info">
                <h2 className="title">{t('F_title')}</h2>
            </div>
            <Swiper
                className="blogs"
                modules={[Navigation]}
                spaceBetween={gap}
                // centeredSlides={gap !== 16}
                slidesPerView={'auto'}
                initialSlide={0}
                navigation
                // pagination={{ clickable: true }}
                onSlideNextTransitionEnd={() => {
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'activity_button',
                        page_name: t('A_label'),
                        list_name: t('F_title'),
                        button_name: '>',
                        function: 'Flip Cards',
                    });
                }}
                onSlidePrevTransitionEnd={() => {
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'activity_button',
                        page_name: t('A_label'),
                        list_name: t('F_title'),
                        button_name: '<',
                        function: 'Flip Cards',
                    });
                }}
            >
                {blogs?.map((blog: BlogType, k: number) => (
                    <SwiperSlide className={`blog item-${k + 1}`} key={k}>
                        <div className="blog-content">
                            <ul className="stars">
                                {[1, 2, 3, 4, 5].map((star: number, n: number) => (
                                    <li className="star">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                                            <path
                                                d="M8.01715 0.334814L9.88789 4.3062C9.97103 4.48414 10.1337 4.60718 10.3217 4.63557L14.506 5.2716C14.9777 5.34353 15.1675 5.95117 14.8259 6.30136L11.7984 9.39442C11.6628 9.53261 11.6014 9.73326 11.6321 9.92823L12.346 14.2933C12.4274 14.7855 11.9321 15.1622 11.511 14.9294L7.76772 12.868C7.59963 12.7752 7.399 12.7752 7.2309 12.868L3.48944 14.9294C3.06649 15.1622 2.57305 14.7855 2.65438 14.2933L3.36834 9.92823C3.40087 9.73326 3.33761 9.53261 3.20205 9.39442L0.174532 6.30325C-0.167081 5.95495 0.0208965 5.34542 0.494454 5.27349L4.67875 4.63747C4.86673 4.60907 5.0294 4.48603 5.11255 4.30809L6.98328 0.336707C7.19475 -0.11192 7.80568 -0.11192 8.01715 0.334814Z"
                                                fill="#F7A40A"
                                            />
                                        </svg>
                                    </li>
                                ))}
                            </ul>
                            <p className="blog-text">"{blog.text}"</p>
                        </div>
                        <div className="blog-img">
                            <EfImg pc={blog.img} />
                        </div>
                        <p className="blog-author">{blog.author}</p>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
